import { DashboardPage } from "@/modules/dashboard/pages";
import { AppPaths } from "@/shared/common/enums";
import { Layout } from "@/shared/layout";
import type { RouteObject } from "react-router-dom";

export const dashboardRoutes: RouteObject = {
  path: "",
  element: <Layout />,
  children: [
    {
      path: AppPaths.Dashboard, element: <DashboardPage />,
      children: [
        { path: ":section?", element: <DashboardPage /> },
      ],
    },
  ],
};

